import React, { useMemo, memo } from "react";
import PropertyGroup from "./PropertyGroup";

const WeeklyView = memo(function WeeklyView({
  dayNames,
  tasksByProperty,
  currentWeekStart,
  propertyNameToIdMap,
  propertyKeyMap,
  handleTaskClick,
  handleToggle,
}) {
  // Memoize day dates calculation (only recalculates when currentWeekStart changes)
  const dayDates = useMemo(() => {
    const dates = {};
    const dayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    dayOrder.forEach((dayKey, index) => {
      const dayDate = new Date(currentWeekStart);
      dayDate.setDate(dayDate.getDate() + index);
      dates[dayKey] = dayDate;
    });
    return dates;
  }, [currentWeekStart]);

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
      }}
    >
      {dayNames.map((dayKey) => {
        const dayData = tasksByProperty[dayKey] || {};
        // Sort properties (simple operation, no need to memoize per day)
        const propertiesInDay = Object.keys(dayData).sort((a, b) => a.localeCompare(b));
        
        // Get the actual date for this day (from memoized calculation)
        const dayDate = dayDates[dayKey];

        return (
          <div
            key={dayKey}
            style={{
              flex: "1 1 0",
              minWidth: 0,
              border: "1px solid #e6e9ef",
              borderRadius: 8,
              padding: 8,
              background: "#ffffff",
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#323338",
                marginBottom: 8,
                textAlign: "center",
                paddingBottom: 8,
                borderBottom: "1px solid #e6e9ef",
              }}
            >
              {dayKey}
              <div style={{ fontSize: 11, fontWeight: 400, color: "#676879", marginTop: 2 }}>
                {dayDate.toLocaleDateString("en-US", { month: "short", day: "numeric" })}
              </div>
            </div>

            <div>
              {propertiesInDay.length === 0 ? (
                <div
                  style={{
                    color: "#a1a4b5",
                    fontSize: 12,
                    fontStyle: "italic",
                    textAlign: "center",
                    padding: "20px 0",
                  }}
                >
                  No tasks
                </div>
              ) : (
                propertiesInDay.map((propertyName) => {
                  const tasks = dayData[propertyName] || [];
                  return (
                     <div
                       key={propertyName}
                       style={{
                         position: "relative",
                         marginBottom: 8,
                         padding: "8px 8px 4px 8px",
                         background: "#e6e9ef",
                         borderRadius: 6,
                         zIndex: 0,
                       }}
                     >
                      <div style={{ position: "relative", zIndex: 1 }}>
                        <PropertyGroup
                          propertyName={propertyName}
                          tasks={tasks}
                          propertyNameToIdMap={propertyNameToIdMap}
                          propertyKeyMap={propertyKeyMap}
                          handleTaskClick={handleTaskClick}
                          handleToggle={handleToggle}
                          isWeekly={true}
                        />
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default WeeklyView;

